import styles from './BaseInput.scss';
import { classNames } from '@/lib/classNames';
import { UseFormRegisterReturn } from 'react-hook-form';
import { ErrorLabel } from './ErrorLabel';

type ElementProps = JSX.IntrinsicElements['input'];
type Props = ElementProps & {
  error?: string;
  register?: UseFormRegisterReturn;
};

/** BaseInput */
export const BaseInput: React.FC<Props> = ({ className, error, register, ...props }) => {
  return (
    <>
      <input {...props} {...register} className={classNames('base-input', className)} />
      {error && <ErrorLabel className="base-input__error">{error}</ErrorLabel>}
      <style jsx>{styles}</style>
    </>
  );
};
